<!--
    3D设计变更方案
 -->
<template>
    <div class="content">
        <!-- <div v-for="(item,index) in arrMent">
            <progTaber :changeTime="item.title" :planNumber="item.number" :planType="item.type"
                :planDesigner="item.designer" :planTime="item.approval" :isType="item.isType"></progTaber>
        </div> -->
        <div class="header-box">
            <div class="header-info">
                <div class="flex">
                    <div class="top-title">{{arrDetails.is_change == 1? '变更方案':'方案设计' }}</div>
                    <div class="top-order" v-if="arrDetails.is_change == 0">{{arrDetails.new_name}}</div>
                </div>
                <div class="time-title">提交时间：{{arrDetails.new_submit_time}}</div>
            </div>
            <div class="preparation-icon">
                <div v-if="arrDetails.new_approvalstatus == 1"><img
                        src="../../../assets/images/archives/preparation.png" /></div>
                <div v-if="arrDetails.new_approvalstatus == 2"><img
                        src="../../../assets/images/archives/reviewing.png" /></div>
                <div v-if="arrDetails.new_approvalstatus == 3"><img
                        src="../../../assets/images/archives/reviewed.png" /></div>
                <div v-if="arrDetails.new_approvalstatus == 4"><img
                        src="../../../assets/images/archives/rejected.png" /></div>
                <div v-if="arrDetails.new_approvalstatus == 5"><img
                        src="../../../assets/images/archives/unqualified.png" /></div>
            </div>
        </div>
        <!-- 选择框 -->
        <div class="taber-box">
            <div :class="nTaber==index?'taber-title-item':'taber-title'" v-for="(item,index) in arrTaber" :key="index"
                @click="changeTaber(index)">
                {{item.title}}
            </div>
        </div>
        <!-- 选择框 > 设计信息 -->
        <div v-if="nTaber == 0">
            <div class="list-box">
                <!-- <div class="list-content flex" v-for="(item,index) in arrList" :key="index"
                    :style="{background: (index % 2 == 0 ? '#fff':'#F9F9FB')}">
                    <div class="item-title">{{item.title}}</div>
                    <div class="right-box">
                        <div v-if="item.type" class="item-type">{{item.type}}</div>
                        <div :class="item.content == '暂无'?'item-content-item':'item-content'">{{item.content}}</div>
                    </div>
                </div> -->
                <div class="list-content flex" :style="{background: ( true ? '#fff':'#F9F9FB')}">
                    <div class="item-title">方案编号：</div>
                    <div class="right-box" v-if="arrDetails.new_name">{{arrDetails.new_name}}</div>
                    <div class="notyet" v-else>暂无</div>
                </div>
                <div class="list-content flex" :style="{background: ( false ? '#fff':'#F9F9FB')}">
                    <div class="item-title">锅炉台数：</div>
                    <div class="right-box" v-if="arrDetails.new_boilernumber">{{arrDetails.new_boilernumber}}</div>
                    <div class="notyet" v-else>暂无</div>
                </div>
                <div class="list-content flex" :style="{background: ( true ? '#fff':'#F9F9FB')}">
                    <div class="item-title">地暖面积：</div>
                    <div class="right-box" v-if="arrDetails.new_area">{{arrDetails.new_area}}</div>
                    <div class="notyet" v-else>暂无</div>
                </div>
                <div class="list-content flex" :style="{background: ( false ? '#fff':'#F9F9FB')}">
                    <div class="item-title">暖气片组数：</div>
                    <div class="right-box" v-if="arrDetails.new_group">{{arrDetails.new_group}}</div>
                    <div class="notyet" v-else>暂无</div>
                </div>
                <div class="list-content flex" :style="{background: ( true ? '#fff':'#F9F9FB')}">
                    <div class="item-title">风机盘管组数：</div>
                    <div class="right-box" v-if="arrDetails.new_fancoilgroup">{{arrDetails.new_fancoilgroup}}</div>
                    <div class="notyet" v-else>暂无</div>
                </div>
                <div class="list-content flex" :style="{background: ( false ? '#fff':'#F9F9FB')}">
                    <div class="item-title">市政供暖对接：</div>
                    <div class="right-box" v-if="arrDetails.new_isgovernment">{{arrDetails.new_isgovernment}}</div>
                    <div class="notyet" v-else>暂无</div>
                </div>
                <div class="list-content flex" :style="{background: ( true ? '#fff':'#F9F9FB')}">
                    <div class="item-title">室外机安装空间：</div>
                    <div class="right-box" v-if="arrDetails.new_installspace">{{arrDetails.new_installspace}}</div>
                    <div class="notyet" v-else>暂无</div>
                </div>
                <div class="list-content flex" :style="{background: ( false ? '#fff':'#F9F9FB')}">
                    <div class="item-title">室外机安装形式：</div>
                    <div class="right-box" v-if="arrDetails.new_installstyle">{{arrDetails.new_installstyle}}</div>
                    <div class="notyet" v-else>暂无</div>
                </div>
                <div class="list-content flex" :style="{background: ( true ? '#fff':'#F9F9FB')}">
                    <div class="item-title">地暖套餐：</div>
                    <div class="right-box" v-if="arrDetails.new_floorheatpackage">{{arrDetails.new_floorheatpackage}}
                    </div>
                    <div class="notyet" v-else>暂无</div>
                </div>
                <div class="list-content flex" :style="{background: ( false ? '#fff':'#F9F9FB')}">
                    <div class="item-title">锅炉型号：</div>
                    <div class="right-box" v-if="arrDetails.new_boilermodel">{{arrDetails.new_boilermodel}}</div>
                    <div class="notyet" v-else>暂无</div>
                </div>
                <div class="list-content flex" :style="{background: ( true ? '#fff':'#F9F9FB')}">
                    <div class="item-title">暖气片类型：</div>
                    <div class="right-box" v-if="arrDetails.new_radiatortype">{{arrDetails.new_radiatortype}}</div>
                    <div class="notyet" v-else>暂无</div>
                </div>
                <div class="list-content flex" :style="{background: ( false ? '#fff':'#F9F9FB')}">
                    <div class="item-title">风机盘管类型：</div>
                    <div class="right-box" v-if="arrDetails.new_fancoiltype">{{arrDetails.new_fancoiltype}}</div>
                    <div class="notyet" v-else>暂无</div>
                </div>
                <div class="list-content flex" :style="{background: ( true ? '#fff':'#F9F9FB')}">
                    <div class="item-title">延米：</div>
                    <div class="right-box" v-if="arrDetails.new_extendedmeter">{{arrDetails.new_extendedmeter}}</div>
                    <div class="notyet" v-else>暂无</div>
                </div>
                <div class="list-content flex" :style="{background: ( false ? '#fff':'#F9F9FB')}">
                    <div class="item-title">新风机型号：</div>
                    <div class="right-box" v-if="arrDetails.new_freshairmodel">{{arrDetails.new_freshairmodel}}</div>
                    <div class="notyet" v-else>暂无</div>
                </div>
                <div class="list-content flex" :style="{background: ( true ? '#fff':'#F9F9FB')}">
                    <div class="item-title">新风主机台数：</div>
                    <div class="right-box" v-if="arrDetails.new_freshairnumber">{{arrDetails.new_freshairnumber}}</div>
                    <div class="notyet" v-else>暂无</div>
                </div>
                <div class="list-content flex" :style="{background: ( false ? '#fff':'#F9F9FB')}">
                    <div class="item-title">分风箱型号：</div>
                    <div class="right-box" v-if="arrDetails.new_airboxmodel">{{arrDetails.new_airboxmodel}}</div>
                    <div class="notyet" v-else>暂无</div>
                </div>
                <div class="list-content flex" :style="{background: ( true ? '#fff':'#F9F9FB')}">
                    <div class="item-title">送风口数量：</div>
                    <div class="right-box" v-if="arrDetails.new_supplyairnumber">{{arrDetails.new_supplyairnumber}}
                    </div>
                    <div class="notyet" v-else>暂无</div>
                </div>
                <div class="list-content flex" :style="{background: ( false ? '#fff':'#F9F9FB')}">
                    <div class="item-title">回风口数量：</div>
                    <div class="right-box" v-if="arrDetails.new_returnairnumber">{{arrDetails.new_returnairnumber}}
                    </div>
                    <div class="notyet" v-else>暂无</div>
                </div>
                <div class="list-content flex" :style="{background: ( true ? '#fff':'#F9F9FB')}">
                    <div class="item-title">是否需要收费：</div>
                    <div class="right-box" v-if="arrDetails.new_ischarge">{{arrDetails.new_ischarge}}</div>
                    <div class="notyet" v-else>暂无</div>
                </div>
                <div class="list-content flex" :style="{background: ( false ? '#fff':'#F9F9FB')}">
                    <div class="item-title">审批时间：</div>
                    <div class="type-box">
                        <div class="type-button" v-if="arrDetails.new_approvalstatus == 1">制单</div>
                        <div class="type-button" v-if="arrDetails.new_approvalstatus == 2">审核中</div>
                        <div class="type-button" v-if="arrDetails.new_approvalstatus == 3">已审核</div>
                        <div class="type-button" v-if="arrDetails.new_approvalstatus == 4">已驳回</div>
                        <div class="type-button" v-if="arrDetails.new_approvalstatus == 5">已否决</div>
                        <div class="type-time-title" v-if="arrDetails.new_approved_time">
                            {{arrDetails.new_approved_time}}
                        </div>
                        <div class="notyet" v-else>暂无</div>
                    </div>
                </div>
                <div class="list-content flex" :style="{background: ( true ? '#fff':'#F9F9FB')}">
                    <div class="item-title">备注：</div>
                    <div class="right-box" v-if="arrDetails.new_memo">{{arrDetails.new_memo}}</div>
                    <div class="notyet" v-else>暂无</div>
                </div>
            </div>
        </div>
        <!-- 选择框 > 设计附件 -->
        <div v-show="nTaber == 1">
            <div>
                <div class="list-box" v-for="(item,index) in arrChlist" :key="index">
                    <div class="list-top-box">
                        <div class="list-title">{{item.name}}</div>
                    </div>
                    <div class="type-item-img">
                        <div class="item-img" v-for="(it,inx) in item.imageValue">
                            <img @click="clickImg(item.value,inx)" :src="it.new_filepath" />
                        </div>
                        <div class="arrPdf-item" v-for="(ix,im) in item.pdfValue" @click="getPDF(ix.new_filepath)">
                            <div>{{ix.notetext}}</div>
                            <div>下载</div>
                        </div>
                    </div>
                    <div class="arrPdf-box">

                    </div>
                </div>
            </div>
            <van-image-preview v-model="imgShow" :closeable="true" :startPosition="lookImgIndex" :images="arrImg">
            </van-image-preview>
        </div>
        <!-- 选择框 > 3D方案 -->
        <div v-if="nTaber == 2" class="iframe-box">
            <iframe :src="arrDetails.new_designurl"></iframe>
        </div>
        <!-- 选择框 > 审批流 -->
        <div v-if="nTaber == 3" class="approval-box">
            <!-- 流程 -->
            <div class="flow-box">
                <div class="flex">
                    <div class="flow-title">审批流程</div>
                    <div class="step_unfold" @click="touchUnfold">
                        <p>{{ !isUnfold ? '收起' : '展开' }}</p>
                        <img :class="{'arrow':isUnfold,'arrow2':!isUnfold}"
                            src="~@/assets/images/archives/dossier/arrow_icon2.png" alt="">
                    </div>
                </div>
                <div class="arrProlwen" :style="isUnfold ? 'display: none;':''">
                    <div class="record-box" v-for="(item,index) in arrApproval">
                        <div class="timeline flex">
                            <div style="display: flex;">
                                <div class="time-icon"><img src="~@/assets/images/archives/dossier/time_icon.png" />
                                </div>
                                <div class="data-detail">{{item.new_name}}</div>
                            </div>
                            <div>
                                <div class="data-type">{{item.new_status_txt}}</div>
                            </div>
                        </div>
                        <div class="boder-box">
                            <div class="data-box">
                                <div class="time-content">{{item.username}}</div>
                                <div class="signIn-name">{{item.new_approvedate}}</div>
                            </div>
                            <div class="new-result">{{item.new_result}}</div>
                        </div>
                    </div>
                </div>
            </div>
            <!-- 审批记录 -->
            <div class="flow-box">
                <div class="flex">
                    <div class="flow-title">审批记录</div>
                </div>
                <div class="arrProlwen">
                    <div class="record-box" v-for="(item,index) in arrRecord">
                        <div class="timeline">
                            <div class="time-icon">
                                <img src="../../../assets/images/archives/workOrder/time-icon.png" />
                            </div>
                            <div class="record-time">{{item.data}}</div>
                        </div>
                        <div class="recoas-box"></div>
                        <div v-for="(it,inx) in item.value" :key="inx" class="ment-box">
                            <div class="ment-top">
                                <div class="ment-date">{{it.new_date_min}}</div>
                                <div class="ment-name">{{it.new_name}}</div>
                            </div>
                            <div class="ment-bottom">
                                <div class="bottom-username">{{it.new_username}}</div>
                                <div class="approvestep_name">[{{it.new_actionName}}]</div>
                            </div>
                            <div class="new_memo">{{it.new_memo}}</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- <div class="footer-box">
            <div class="footer-btn-box">
                <div class="footer-btn">查看变更记录</div>
                <div class="footer-btn">修改设计方案</div>
                <div class="footer-btn">提交审核</div>
            </div>
        </div> -->
        <img class="back_icon" @click="touchBack" src="~@/assets/images/archives/dossier/back_icon.png" />
    </div>
</template>

<script>
    import progTaber from '../dossier/components/prog_taber/index.vue';
    import oData from '@/js/archives/survey/index.js'
    export default {
        components: {
            progTaber,
        },
        data() {
            return {
                arrTaber: [{
                    title: '设计信息',
                }, {
                    title: '设计附件',
                }, {
                    title: '3D方案',
                }, {
                    title: '审批流',
                }],
                nTaber: 0,
                arrList: [],
                arrBasicInfo: [],
                project_id: '',
                projectdesign_id: '',
                arrDetails: [],
                arrMent: [],
                arrChlist: [],
                detailsType: '',
                lookImgIndex: 0,
                imgShow: false,
                arrImg: [],
                arrApproval: [],
                arrRecord: [],
                isUnfold: false,
            }
        },
        created() {
            this.project_id = this.$route.query.id
            this.projectdesign_id = this.$route.query.prog
            console.log(this.$route.query.id, 'title')
            this.getDetails()
        },
        methods: {
            changeTaber(index) {
                this.nTaber = index
                console.log(index)
                if (index == 1) {
                    this.getChlist()
                } else if (index = 3) {
                    this.getAppvals()
                }
            },
            getDetails() {
                this.$store.commit("loadSwitch", true);
                oData.projectChange({
                    // type: 1,
                    project_id: this.project_id,
                    projectdesign_id: this.projectdesign_id
                }).then(res => {
                    this.$store.commit("loadSwitch", false);
                    this.arrDetails = res.data.data.result.detail1
                })
            },
            getChlist() {
                this.$store.commit("loadSwitch", true);
                oData.attachlist({
                    projectdesign_id: this.projectdesign_id
                }).then(res => {
                    this.$store.commit("loadSwitch", false);
                    let arrObject = {
                        ...res.data.data.result
                    };
                    let list = [];
                    for (var key in arrObject) {
                        var temp = {}
                        temp.name = key;
                        temp.value = arrObject[key];
                        list.push(temp)
                    }
                    let arr = [];
                    let arrImg = []
                    list.forEach((it,j) =>{
                        let arrPdf = it.value.filter(ix=>{
                            return ix.mimetype != 'image/png'
                        })
                        let arrImage = it.value.filter(ix=>{
                            return ix.mimetype == 'image/png'
                        })
                        it.imageValue = arrImage
                        it.pdfValue = arrPdf;
                    })
                    this.arrChlist = list
                    console.log(list, '---')
                    this.$previewRefresh()
                })
            },
            //审批流数据
            getAppvals() {
                this.$store.commit("loadSwitch", true);
                oData.DesginApproval({
                    projectdesign_id: this.projectdesign_id,
                }).then(res => {
                    this.$store.commit("loadSwitch", false);
                    this.arrApproval = res.data.data.result.steps
                    let arr = res.data.data.result.loglist
                    let arrData = []
                    for (let key in arr) {
                        let obj = {}
                        obj.data = key
                        obj.value = arr[key]
                        arrData.push(obj)
                    }
                    this.arrRecord = arrData
                })
            },
            //点击放大图片
            clickImg(item, index) {
                let arrImg = []
                item.forEach(it =>{
                    if(it.mimetype == 'image/png'){
                        arrImg.push(it.new_filepath)
                    }
                })
                this.lookImgIndex = index
                this.arrImg = arrImg
                this.imgShow = true
            },
            touchUnfold(i) {
                this.isUnfold = !this.isUnfold;
            },
            //PDF,excle预览
            getPDF(url){
                console.log(123)
                window.location.href = url
            },
            touchBack(){
                this.$router.back()
            }
        },
        watch: {}
    }
</script>

<style lang="scss" scoped>
    .flex {
        display: flex;
        justify-content: space-between;
    }

    .type-item-img::-webkit-scrollbar {
        display: none
    }

    .content {
        width: 100%;
        background: #F3F6FF;
        height: 100%;
        min-height: 100vh;
        padding: 32px;
        padding-bottom: 28px;

        .header-box {
            display: flex;
            justify-content: space-between;

            .header-info {
                .flex {
                    display: flex;

                    .top-title {
                        font-size: 36px;
                        font-family: PingFang SC-Semibold, PingFang SC;
                        font-weight: 600;
                        color: #333333;
                    }

                    .top-order {
                        font-family: PingFang SC-Regular, PingFang SC;
                        font-weight: 400;
                        color: rgba(85, 85, 85, 0.6);
                        margin-left: 52px;
                        margin-top: 14px;
                    }
                }

                .big-title {
                    font-size: 36px;
                    font-family: PingFang SC-Semibold, PingFang SC;
                    font-weight: 600;
                    color: #333333;
                }

                .time-title {
                    margin-top: 16px;
                    font-size: 24px;
                    font-family: PingFang SC-Regular, PingFang SC;
                    font-weight: 400;
                    color: #555555;
                }
            }

            .preparation-icon {
                img {
                    width: 160.74px;
                    height: 152px;
                }
            }
        }

        .taber-box {
            width: 100%;
            height: 80px;
            background: #FFFFFF;
            border-radius: 16px;
            margin-top: 28px;
            display: flex;
            justify-content: space-evenly;

            .taber-title {
                text-align: center;
                line-height: 80px;
                font-size: 24px;
                font-family: PingFang SC-Regular, PingFang SC;
                font-weight: 400;
                color: #A3A3A3;
            }

            .taber-title-item {
                text-align: center;
                line-height: 80px;
                font-size: 24px;
                font-family: PingFang SC-Semibold, PingFang SC;
                font-weight: 600;
                color: #0D53FC;
                border-bottom: #0D53FC 5px solid;
            }
        }

        .list-box {
            margin-top: 16px;

            .list-content:First-child {
                border-radius: 16px 16px 0 0;
            }

            .list-content:last-child {
                border-radius: 0 0 16px 16px;
            }

            .list-content {
                padding: 22px 48px 24px 48px;

                .item-title {
                    font-size: 24px;
                    font-family: PingFang SC-Regular, PingFang SC;
                    font-weight: 400;
                    color: #999999;
                }

                .right-box {
                    // display: flex;
                    font-size: 24px;
                    color: #333333;
                    width: 340px;
                    text-align: right;
                }

                .notyet {
                    font-size: 24px;
                    color: #999999;
                    width: 330px;
                    text-align: right;
                }

                .type-box {
                    display: flex;

                    .type-button {
                        padding: 4px 28px;
                        background: #74B176;
                        border-radius: 106px;
                        color: #fff;
                    }

                    .type-time-title {
                        font-size: 24px;
                        color: #333333;
                        width: 330px;
                        text-align: right;
                        width: 140px;
                        line-height: 42px;
                    }



                    .notyet {
                        font-size: 24px;
                        color: #999999;
                        width: 330px;
                        text-align: right;
                    }
                }
            }

            .type-item-img {
                padding: 0 34px 32px 34px;
                overflow-x: scroll;
                width: 100%;
                background: #FFF;
                white-space: nowrap;
                border-radius: 0 0 16px 16px;

                .item-img {
                    width: 160px;
                    height: 160px;
                    display: inline-block;
                    margin-right: 16px;

                    img {
                        border-radius: 16px;
                        width: 100%;
                        height: 100%;
                        display: block;
                        object-fit: cover;
                    }
                }
                .arrPdf-item{
                    margin-top: 18px;
                    height: 68px;
                    width: 100%;
                    background: #ced7de;
                    border-radius: 18px;
                    color: #5b83bf;
                    padding: 0 12px;
                    line-height: 68px;
                    display: flex;
                    justify-content: space-between;
                }
            }

            .list-top-box {
                width: 100%;
                padding: 36px 44px;
                background: #fff;
                margin-top: 16px;
                border-radius: 16px 16px 0 0;

                .list-title {
                    font-size: 24px;
                    font-family: PingFang SC-Medium, PingFang SC;
                    font-weight: 600;
                    color: #333333;
                    padding-left: 16px;
                    border-left: #0D53FC 5px solid;
                }
            }

        }

        .iframe-box {
            margin: 0 -34px;
            margin-top: 16px;

            iframe {
                width: 100%;
                height: 70vh;
            }
        }

        .approval-box {

            .flow-box {
                margin-top: 16px;
                border-radius: 16px;
                background: #FFF;
                padding: 32px 44px;

                .flow-title {
                    font-size: 24px;
                    font-family: PingFang SC-Medium, PingFang SC;
                    font-weight: 600;
                    color: #333333;
                    padding-left: 16px;
                    border-left: #0D53FC 5px solid;
                }

                .step_unfold {
                    display: flex;
                    margin-left: auto;

                    p {
                        font-size: 24px;
                        font-family: PingFang SC-Medium, PingFang SC;
                        font-weight: bold;
                        color: #0D53FC;
                        line-height: 34px;
                    }

                    .arrow {
                        width: 24px;
                        height: 24px;
                        display: block;
                        margin-left: 8px;
                        transition: transform 0.2s;
                        transform: rotate(180deg);
                        margin-top: 2px;
                    }

                    .arrow2 {
                        width: 24px;
                        height: 24px;
                        display: block;
                        margin-left: 8px;
                        transition: transform 0.2s;
                        transform: rotate(0deg);
                        margin-top: 2px;
                    }
                }

                .arrProlwen {
                    margin-top: 20px;

                    .record-box {
                        // display: flex;
                        width: 100%;
                        // padding: 0 0 0 46px;
                        background: #FFF;

                        .timeline {
                            display: flex;

                            .time-icon {
                                img {
                                    width: 64px;
                                    height: 64px;
                                }
                            }

                            .record-time {
                                font-size: 28px;
                                font-family: PingFang SC-Semibold, PingFang SC;
                                font-weight: 600;
                                color: #333333;
                                line-height: 64px;
                                margin-left: 32px;
                            }

                            .data-detail {
                                width: 300px;
                                margin-left: 30px;
                                font-size: 24px;
                                font-family: PingFang SC-Regular, PingFang SC;
                                font-weight: 400;
                                color: #999999;
                            }

                            .data-type {
                                font-size: 24px;
                                font-family: PingFang SC-Regular, PingFang SC;
                                font-weight: 400;
                                color: #999999;
                            }
                        }

                        .recoas-box {
                            padding-bottom: 64px;
                            margin-left: 30px;
                            border-left: 4px dashed #EEEEEE;
                        }

                        .ment-box {
                            .ment-top {
                                display: flex;
                                .ment-date {
                                    font-size: 24px;
                                    font-family: PingFang SC-Regular, PingFang SC;
                                    font-weight: 400;
                                    color: #999999;
                                }

                                .ment-name {
                                    margin-left: 30px;
                                    font-size: 24px;
                                    font-family: PingFang SC-Regular, PingFang SC;
                                    font-weight: 400;
                                    color: #999999;
                                }
                            }

                            .ment-bottom {
                                padding: 20px 0 24px 56px;
                                margin-left: 30px;
                                border-left: 4px dashed #EEEEEE;
                                display: flex;
                                justify-content: space-between;
                                .bottom-username{
                                    font-size: 28px;
                                    font-family: PingFang SC-Semibold, PingFang SC;
                                    font-weight: 600;
                                    color: #333333;
                                }
                                .approvestep_name{
                                    font-size: 24px;
                                    font-family: PingFang SC-Regular, PingFang SC;
                                    font-weight: 400;
                                    color: #333333;
                                }
                            }
                            .new_memo{
                                padding: 20px 0px 64px 56px;
                                margin-left: 30px;
                                border-left: 4px dashed #EEEEEE;
                            }
                        }

                        .boder-box {
                            padding-bottom: 64px;
                            margin-left: 30px;
                            border-left: 4px dashed #EEEEEE;

                            .data-box {
                                display: flex;
                                justify-content: space-between;
                                margin-left: 56px;
                                margin-top: 10px;

                                .time-title {
                                    font-size: 28px;
                                    font-family: PingFang SC-Regular, PingFang SC;
                                    font-weight: 600;
                                    color: #000000;
                                }

                                .signIn {
                                    font-size: 22px;
                                    font-family: PingFang SC-Regular, PingFang SC;
                                    font-weight: 400;
                                    color: #999999;
                                    line-height: 40px;
                                }
                            }

                            .new-result {
                                margin: 16px 0 0 56px;
                                font-size: 24px;
                                font-family: PingFang SC-Regular, PingFang SC;
                                font-weight: 400;
                                color: #999999;
                            }
                        }



                        .signIn-content {
                            padding: 0 0 64px 58px;
                            margin: 0px 0 0 30px;
                            border-left: 4px dashed #EEEEEE;

                            .signIn-title {
                                margin-top: 16px;
                                font-size: 24px;
                                font-family: PingFang SC-Regular, PingFang SC;
                                font-weight: 400;
                                color: #999999;
                            }

                            .contentImg {
                                margin-top: 16px;
                                display: flex;
                                flex-wrap: wrap;

                                .signIn-img {
                                    margin: 16px 16px 0 0;

                                    img {
                                        width: 160px;
                                        height: 160px;
                                        border-radius: 16px;
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }

        .footer-box {
            width: 100%;
            height: 138px;
            position: absolute;
            bottom: 0;
            left: 0;
            background: #FFF;
            padding: 0 32px;
            box-shadow: 0px -4px 8px 0px rgba(0, 0, 0, 0.0300);

            .footer-btn-box {
                display: flex;
                justify-content: flex-end;

                .footer-btn {
                    margin-top: 24px;
                    width: 160px;
                    height: 64px;
                    text-align: center;
                    line-height: 64px;
                    background: #0D53FC;
                    border-radius: 16px 16px 16px 16px;
                    font-size: 24px;
                    font-family: PingFang SC-Medium, PingFang SC;
                    color: #FFFFFF;
                    margin-left: 24px;
                }
            }
        }
        .back_icon{
            position: fixed;
            left: 32px;
            bottom: calc(env(safe-area-inset-bottom) + 150px);
            z-index: 999;
            width: 100px;
            height: 100px;
        }
    }
</style>
